import { EncryptionService } from './../services/encryption.service';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SlimLoadingBarService } from 'ops-lib';
import { NgSpinnerService } from 'ops-lib';
import { environment } from 'src/environments/environment';
const tokenEndPoint = 'oauth2/token';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  excludedUrls = [];

  constructor(
    private auth: AuthService,
    private slimLoadingBarService: SlimLoadingBarService,
    private encryptionService: EncryptionService,
    public ngSpinnerService: NgSpinnerService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // HERE REQUEST INTERCEPTOR
    // Get the auth token from the service.
    const authToken = this.auth.getAccessToken();
    const endPoint = `${environment.identityApiBaseUrl}${tokenEndPoint}`;
    const excludedUrls = [
      endPoint,
    ];
    let authReq: any;
    if (excludedUrls.some(x => x === req.url)) {
      authReq = req.clone();
    } else {
      if (req.body && req.body['encrypted'] === true) {
        const jsonBody = JSON.stringify(req.body);
        authReq = req.clone({
          body: this.encryptionService.set(jsonBody),
          setHeaders: { Authorization: 'Bearer ' + authToken }
        });
      } else {
        authReq = req.clone({ setHeaders: { Authorization: 'Bearer ' + authToken } });
      }
    }
    this.slimLoadingBarService.start();
    this.ngSpinnerService.visible = true;
    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
